import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from "rxjs";

export interface TeleportInstance {
  [target: string]: TemplateRef<any> | null;
}

@Injectable({
  providedIn: 'root'
})
export class TeleportService extends BehaviorSubject<TeleportInstance | null> {

  constructor() {
    super(null);
  }

  public activate(instance: TeleportInstance | { [key: string]: null }): void {
    this.next(instance);
  }

}
